module.exports = __webpack_public_path__ + "static/lawfirm-cafa3b36d7ddbb42c64622075ecbb9a3.jpg";